import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PageBuilder from "../components/page-builder"
import { BasicPage } from "@hurleymc/components"
import Subnav from "../components/subnav"

const PageBasicPage = ({ data }) => {
  const { craft } = data
  const { entries } = craft
  const entry = entries[0]
  const image =
    entry.images && entry.images.length > 0 && entry.images[0].lg
      ? entry.images[0].lg
      : null
  return (
    <Layout>
      <SEO title={entry.title} image={image} />
      <Subnav entry={entry} />
      <BasicPage title={entry.title} images={entry.images} />
      {entry && entry.pageBuilder && (
        <PageBuilder
          pageBuilder={entry.pageBuilder}
          location={{ pathname: entry.uri }}
        />
      )}
    </Layout>
  )
}

export const query = graphql`
  query PageBasicPage($id: [Craft_QueryArgument]!) {
    craft {
      entries(site: "hurleyGme", id: $id) {
        __typename
        title
        uri
        ... on Craft_gmePage_basicPage_Entry {
          images {
            ... on Craft_AssetInterface {
              title
              url
              lg: url(transform: "splashLg", immediately: true)
              xl: url(transform: "splashXl", immediately: true)
            }
          }
          pageBuilder {
            ...PageBuilder
          }
        }
      }
    }
  }
`

export default PageBasicPage
